<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div class="LineClassPicker">
      <div>
        <van-cell icon="logistics" title="路线" :value="line.text" />
        <van-cell icon="clock-o" title="始发时间" :value="lineClassDay.ClassTime" />
        <van-cell icon="location-o" title="站点" :value="node.NodeName" />
      </div>

      <van-radio-group v-model="checkVehicleGID">
        <van-cell-group title="车辆选择">
          <van-cell icon="warning-o" v-if="VehicleList.length<1" title="暂未派车" />
          <van-cell
            v-for="item in VehicleList"
            :key="item.GID"
            :title="item.VehicleNo+'-('+item.PassengerSeatCount+')'"
            clickable
            @click="onVehicleClick(item)"
          >
            <span v-if="item.SignInOperTime && !item.StartCarTime">已签到</span>
            <span
              v-if="item.StartCarTime || (item.RecordGID && !item.StartCarTime&&!item.SignInOperTime)"
            >已发车</span>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: "车辆选择", //页面标题
      line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次
      node: JSON.parse(window.localStorage.getItem("lineClassDayStratNode")), //选择的站点

      VehicleList: [], //已派车集合
      checkVehicleGID: null
    };
  },
  watch: {},
  methods: {
    //选中车辆
    onVehicleClick(item) {
      this.checkVehicleGID = item.VehicleGID;
      //选中车辆后直接跳转到签到页面
      window.localStorage.setItem("checkVehicle", JSON.stringify(item));
      this.$router.push({
        path: "SignInPage",
        query: {
          isCanBack: "1"
        }
      });
    },
    //班次车辆数据获取
    onQueryLineClassDayVehicleDriver() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        NodeGID: this.node.NodeGID,
        CheckInTime: 0
      };
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then(res => {
          if (res.success) {
            this.VehicleList = res.data;
          }
        });
    }
  },
  mounted: function() {
    this.onQueryLineClassDayVehicleDriver();
  },
  created() {}
};
</script>

<style scoped lang="less">
.LineClassPicker {
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}
.van-cell__value {
  color: black;
}
.van-cell {
  font-size: 14px;
}
.van-cell__label {
  font-size: 12px;
  color: #323233;
}
.cancelSendCarShow {
  width: 80%;
  height: auto;
  text-align: center;
  font-size: 0.4rem;
  border-radius: 0.2rem;
  .title {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    background-color: #eee;
  }
  .content {
    padding: 0.4rem 0;
  }
  .btn {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    display: flex;
    justify-content: space-around;
    padding-bottom: 0.4rem;
    button {
      padding: 0 0.4rem;
      color: #fff;
      border-radius: 0.2rem;
    }
    button:first-child {
      background: #2891e7;
    }
    button:last-child {
      background: #ffb870;
    }
  }
}
</style>
